import { Select } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataDE } from './GetStartedDE';
import styles from './GetStartedDE.module.css';
import { LOAN_DURATION_OPTIONS_DE } from './loanOptions';
import { useLocale } from '../../../hooks/useLocale';

const LoanDurationDE = () => {
  const { i18n } = useLocale();
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataDE>();

  return (
    <Select
      {...register('loanDuration')}
      label={t`How long do you need the loan for?`}
      placeholder={t`Please select`}
      className={clsx({
        [styles.erroredSelect]: errors.loanDuration?.message,
      })}
      error={errors.loanDuration?.message}
    >
      {LOAN_DURATION_OPTIONS_DE.map((option) => (
        <option key={option.value} value={option.value}>
          {i18n._(option.label)}
        </option>
      ))}
    </Select>
  );
};

export default LoanDurationDE;
